import useAuth from "../../hooks/useAuth";
import CheckMark from "../CheckMark";
import classes from "./artistAndUser.module.css";
import { useNavigate } from "react-router-dom";
const ArtistAndUser = ({ data }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const navigateToLoginPage = () => {
    navigate("/login");
  };

  return (
    <>
      {isAuthenticated ? null : (
        <div className={classes.outerMostContainer}>
          <div className={classes.leftCard}>
            <p className={classes.forArtistHeading}>{"For Artists"}</p>
            <p className={`${classes.text} ${classes.greyTxt}`}>
              {
                "Join 570+ musicians, dancers, photographers, and performers already booking gigs on Artist Next Door!"
              }
            </p>

            <div className={classes.tickAndText}>
              <CheckMark tickColor={"#7c08ab"} borderColor={"#abf5b2"} />
              <p className={`${classes.text}`}>
                {
                  "Showcase Your Talent - Create a professional profile & attract event bookings."
                }
              </p>
            </div>

            <div className={classes.tickAndText}>
              <CheckMark tickColor={"#7c08ab"} borderColor={"#abf5b2"} />
              <p className={classes.text}>
                {
                  "Get Paid for Your Passion - Secure wedding gigs, corporate events, and performances with competitive rates"
                }
              </p>
            </div>

            <div className={classes.tickAndText}>
              <CheckMark tickColor={"#7c08ab"} borderColor={"#abf5b2"} />
              <p className={classes.text}>
                {
                  "Network with Top Event Organizers - Connect with planners looking for your exact skills and talents"
                }
              </p>
            </div>

            <button
              onClick={navigateToLoginPage}
              className={classes.signUpBtnArtist}
            >
              {"Sign up as Artist"}
            </button>
          </div>

          <div className={classes.rightCard}>
            <h2 className={classes.forUserHeading}> {"For Users"}</h2>
            <p className={`${classes.text} ${classes.greyTxt}`}>
              {
                "Join 1000+ event planners and users already booking top talent on India's fastest-growing artist platform!"
              }
            </p>
            <div className={classes.tickAndText}>
              <CheckMark borderColor={"#abf5b2"} />
              <p className={classes.textWhite}>
                {
                  "Musicians, dancers, photographers, DJs, magicians & more across major Indian cities"
                }
              </p>
            </div>
            <div className={classes.tickAndText}>
              <CheckMark borderColor={"#abf5b2"} />
              <p className={classes.textWhite}>
                {
                  "Easy Booking Process - Find, compare, and hire perfect artists for weddings, corporate events & celebrations"
                }
              </p>
            </div>

            <div className={classes.tickAndText}>
              <CheckMark borderColor={"#abf5b2"} />
              <p className={classes.textWhite}>
                {"Stress-Free Planning - Book talented artists anywhere."}
              </p>
            </div>
            <button
              onClick={navigateToLoginPage}
              className={classes.signUpBtnUser}
            >
              {"Sign up as User"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ArtistAndUser;
